import React from "react"
interface SectionHeaderProps {
  title: string
}
const SectionHeader = ({ title }: SectionHeaderProps) => {
  return (
    <>
      <h6 className="mt-6 vt-section-header">{title}</h6>
      <hr className="mt-0" />
    </>
  )
}

export default SectionHeader
